import {
  LOAD_PRINT_REQUESTS,
  ADD_PRINT_REQUEST,
  UPDATE_PRINT_REQUEST,
  DELETE_PRINT_REQUEST,
} from 'redux/action_types'


export function loadPrintRequests(response) {
  return {
    type: LOAD_PRINT_REQUESTS,
    ...response,
  }
}

export function addPrintRequest(response) {
  return {
    type: ADD_PRINT_REQUEST,
    ...response
  }
}

export function updatePrintRequest(response) {
  return {
    type: UPDATE_PRINT_REQUEST,
    ...response,
  }
}
export function deletePrintRequest(response) {
  return {
    type: DELETE_PRINT_REQUEST,
    ...response,
  }
}
